import { t } from "@/i18n-js/instance";
import { ThreeDotsDropdownV3 } from "@circle-react-shared/ThreeDotsDropdownV3";
import type { DropdownOptions } from "@circle-react-shared/uikit/Dropdown";
import { useOptionsModal } from "../OptionsModal";

export const ManageCoursesListActionsV3 = () => {
  const optionsModal = useOptionsModal();

  const dropdownOptions: DropdownOptions = [
    {
      icon: "16-file-image",
      label: t("courses.directory.options_menu.banner"),
      onClick: () => optionsModal.show({ tab: "banner" }),
      value: "banner",
    },
    {
      icon: "16-info",
      label: t("courses.directory.options_menu.options"),
      onClick: () => optionsModal.show({ tab: "options" }),
      value: "options",
    },
  ];

  return (
    <ThreeDotsDropdownV3
      label={t("courses.directory.settings_label")}
      options={dropdownOptions}
      dataTestId="courses-directory-settings-v3"
    />
  );
};
